<template>
  <div class="invoice-detail">
    <div class="tip">发票清单详情页</div>
    <orderProcess :transForm="transForm" />
    <div class="container">

      <div class="content-wrapper">
        <div class="title-box">供应商信息</div>
        <div class="detail-box">
          供应商名称 ：
          <span class="black">{{ invoiceData.supplierCompany }}</span>
          <span class="black">{{ `供应商仅支持${invoiceType}发票` }}</span>
        </div>
      </div>
      <div class="content-wrapper">
        <div class="title-box">
          开票信息
          <span class="invoice-info" v-if="Number(invoiceData.invoiceMode) === 1">
          (一票制发票清单的运费分摊已在下单时完成，经供采双方确认后无法修改)
        </span>
        </div>
        <div class="detail-box">
          <div>开票方式 ：
            <el-radio v-model="invoiceData.invoiceMode" :label="1" disabled>一票制</el-radio>
            <el-radio v-model="invoiceData.invoiceMode" :label="2" disabled>两票制</el-radio>
          </div>
            <div>发票形式：
                <span v-if="Number(invoiceData.electronicInvoiceFlag) === 0">纸质发票</span>
                <span v-if="Number(invoiceData.electronicInvoiceFlag) === 1">电子发票</span>
            </div>
          <div>
            开票金额 ：<span class="red" v-if="invoiceData.invoiceMode == 1">¥ {{ invoiceData.totalAmount }} 元</span><span
                  v-else>
          <span>货款金额:<span class="red">{{            invoiceData.productAmount ? `¥ ${invoiceData.productAmount} 元` : ''}}</span></span>
          <span style="margin-left: 10px" v-if="invoiceData.invoiceMode === 2">运费金额:
            <span class="red">{{ invoiceData.shipmentTotalAmount ? `¥ ${invoiceData.shipmentTotalAmount} 元` : '0 元'}}</span>
          </span>
        </span>
          </div>
          <div>发票抬头 ：<span>{{invoiceData.customer}}</span></div>
          <div>开票类型 ：<span class="black">{{ invoiceData.invoiceTypeDesc }}</span></div>
          <div>税号 ：<span class="black">{{ invoiceData.identificationNumber }}</span></div>
          <div>银行及帐号 ：<span class="black">{{ invoiceData.bank }} {{ invoiceData.bankAccount }}</span>
          </div>
          <div>地址及电话 ：<span class="black">{{ invoiceData.registerAddress }} {{ invoiceData.telephone }}</span>
          </div>
        </div>
      </div>

      <div class="content-wrapper">
        <div class="title-box">收发票地址</div>
        <div class="detail-box">
          寄送地址 ：
          <span class="black"
          >{{ invoiceData.address }} {{ invoiceData.receiveName }}
          {{ invoiceData.receivePhone }}</span
          >
        </div>
      </div>

      <div class="content-wrapper" style="border: none;border-top: 1px solid  #D9D9D9;">
        <div class="title-box"
             style="border-bottom: none;border-left: 1px solid  #D9D9D9; border-right: 1px solid  #D9D9D9;">开票订单信息
        </div>
        <el-table
                border
                :data="tableData"
                ref="tableData"
                style="width: 100%"
                row-key="orderId"
                :expand-row-keys="expands"
                @expand-change="expandChange"
                @row-click="rowClick"
                :header-cell-style="{ 'text-align': 'center' }"
                :cell-style="{ 'text-align': 'center' }"
        >
          <el-table-column type="expand">
            <template>
              <el-table
                      :data="orderTableData"
                      style="width: 100%"
                      border
                      :header-cell-style="{ 'text-align': 'center' }"
                      :cell-style="{ 'text-align': 'center' }"
              >
                <el-table-column label="商品名称" min-width="150">
                  <template slot-scope="scope">
                    <div style="text-align: left">
                      {{ scope.row.productName }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="商品规格属性" prop="displaySkuOptions">
                </el-table-column>
                <el-table-column label="商品单价（元）" prop="price">
                </el-table-column>
                <el-table-column label="采购数量" prop="quantity">
                </el-table-column>
                <!--                        <el-table-column label="分摊运费" prop="sentQuantity">-->
                <!--                        </el-table-column>-->
                <el-table-column label="税率（%）" prop="salesTaxRate">
                </el-table-column>
                <el-table-column label="税费（元）" prop="salesTax">
                  <template slot-scope="scope">{{
                    ((scope.row.subtotal * scope.row.salesTaxRate) / 100).toFixed(
                    2
                    )
                    }}
                  </template>
                </el-table-column>
                <el-table-column label="小计（元）" prop="subtotal">
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column label="订单编号" prop="orderNo"></el-table-column>
          <el-table-column label="货款金额（元）" prop="productCost">
          </el-table-column>
          <el-table-column label="运费金额（元）" prop="shippingCost">
          </el-table-column>
          <el-table-column label="下单时间" prop="submitTime"></el-table-column>
        </el-table>
      </div>
      <div class="content-wrapper" v-if="Number(invoiceData.electronicInvoiceFlag) === 1">
          <div class="title-box">发票信息</div>
        <div class="detail-box">
          <el-form size="small">
              <el-form-item label="" label-width="150px">
              <span slot="label"><span class="color-r">*</span>上传电子发票附件:</span>
              <eui-upload
                      :action="uploadUrl"
                      :headers="headers"
                      show-file-list
                      :file-size="10"
                      accept=".pdf,.png,.jpg,.jpeg"
                      :limit="5"
                      text="选择文件"
                      tip="支持PDF、PNG、JPG、JPEG格式的文件，最多可上传5个，每个大小小于10M。"
                      @handleSuccess="uploadSuccess"
              >
              </eui-upload>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div class="flex-sb">
      <el-button type="secondary" @click="closePage">关闭页面</el-button>
      <el-button type="primary" v-if="showFlag === 'receive'" @click="handleSubmit">提交</el-button>
    </div>
  </div>
</template>

<script>
import orderProcess from './orderProcess';
import api from '../../api/order';
import {epecToken} from "../../utils/globalData";
export default {
  components: { orderProcess },
  props: {},
  data() {
    return {
      uploadUrl: api.videoUploadUrl,
      headers: epecToken,
      showFlag: '',
      address: '',
      expands: [],
      tableData: [],
      radio: '2',
      purchaseCompanyId: '',
      invoiceType: '',
      transForm: [
        {
          name: '发送发票清单',
          time: '2021-07-02 15:11:43',
          icon: require('@/assets/img/orderDetail/sent-list.png'),
          activeIcon: require('@/assets/img/orderDetail/sent-list-active.png'),
        },
        {
          name: '待供应商接收发票清单',
          time: '',
          icon: require('@/assets/img/orderDetail/wait-supplier-receive-list.png'),
          activeIcon: require('@/assets/img/orderDetail/wait-supplier-receive-list-active.png'),
        },

        {
          name: '待供应商开票',
          time: '',
          icon: require('@/assets/img/orderDetail/wait-supply-confirm.png'),
          activeIcon: require('@/assets/img/orderDetail/wait-supply-confirm-active.png'),
        },
        {
          name: '完成',
          time: '',
          icon: require('@/assets/img/orderDetail/deal-done.png'),
          activeIcon: require('@/assets/img/orderDetail/deal-done-actice.png'),
        },
      ],
      invoiceTitle: [
        {
          value: '1',
          label: '得力集团有限公司',
        },
        {
          value: '2',
          label: '得力集团有限公司北京分公司',
        },
      ],
      orderInvoiceListId: '',
      invoiceData: {},
      orderTableData: [],
      invoiceAttachments: [],
    };
  },
  methods: {
    uploadSuccess(file) {
      if (file.code === '200') {
        const {data} = file;
        const params = {
          attattachmentName: data.fileName,
          attattachmentUrl: data.url,
        }
        this.invoiceAttachments.push(params);
      }
    },
    // 商品
    async grtListSupplierSku(orderId) {
      await api
        .grtListSupplierSku({
          orderId: orderId,
          purchaseCompanyId: this.invoiceData.purchaseCompanyId,
        })
        .then((res) => {
          if (res.code === '200') {
            this.orderTableData = res.data?.records;
          }
        });
    },
    rowClick(row) {
      this.$refs.tableData.toggleRowExpansion(row);
    },
    async expandChange(row, expandedRows) {
      const { orderId } = row;

      if (!orderId) {
        return;
      }

      await this.grtListSupplierSku(orderId);

      if (expandedRows.length > 1) {
        expandedRows.shift();
      }
      // 只展开一个
      let that = this;
      if (expandedRows.length) {
        that.expands = [];
        if (row) {
          that.expands.push(row.orderId);
        }
      } else {
        that.expands = [];
      }
    },
    getDetail() {
      api
        .detail({
          orderInvoiceListId: this.orderInvoiceListId,
          purchaseCompanyId: this.purchaseCompanyId,
        })
        .then((res) => {
          if (res.code == '200') {
            this.invoiceData = res.data;
            this.purchaseCompanyId = res.data.purchaseCompanyId;
            if (this.invoiceData?.sendTime) {
              this.transForm[0].eventTime = this.invoiceData.createTime;
              this.transForm[1].eventTime = this.invoiceData.receiveTime;
              this.transForm[2].eventTime = this.invoiceData.sendTime;
              this.transForm.forEach((item) => {
                item.light = true;
              });
            } else if (this.invoiceData?.receiveTime) {
              this.transForm[0].eventTime = this.invoiceData.createTime;
              this.transForm[0].light = true;
              this.transForm[1].eventTime = this.invoiceData.receiveTime;
              this.transForm[1].light = true;
              this.transForm[2].light = true;
            } else if (this.invoiceData?.createTime) {
              this.transForm[0].eventTime = this.invoiceData.createTime;
              this.transForm[0].light = true;
              this.transForm[1].light = true;
            }
            this.transForm = [...this.transForm];

            switch (this.invoiceData.invoiceMode) {
              case 1:
                this.invoiceType = '一票制';
                break;
              case 2:
                this.invoiceType = '两票制';
                break;
              case 3:
                this.invoiceType = '一票制、两票制';
                break;
              default:
                this.invoiceType = '';
                break;
            }
          }
        });
    },
    orderList() {
      api
        .orderList({
          orderInvoiceListId: this.orderInvoiceListId,
          purchaseCompanyId: this.purchaseCompanyId,
        })
        .then((res) => {
          if (res.code == '200') {
            this.tableData = res.data.records;
          }
        });
    },
    changeInvoiceType(val) {

    },
    async handleSubmit() {
      if (this.invoiceAttachments.length === 0) {
        this.$message.warning('请上传。');
        return false;
      }

      let params = {
        orderInvoiceListId: this.orderInvoiceListId,
        purchaseCompanyId: this.purchaseCompanyId,
        invoiceAttachments: this.invoiceAttachments
      };
      api.submitElectronicInvoice(params).then((res) => {
        if (res.code == '200') {
          this.$message.success('发票提交成功。');
          this.$router.back();
        }
      });
    },
    closePage() {
      this.$router.back();
    },
  },
  mounted() {
    this.orderInvoiceListId = this.$route.query.orderInvoiceListId;
    this.purchaseCompanyId = this.$route.query.purchaseCompanyId;
    this.showFlag = this.$route.query.showFlag;
    this.getDetail();
    this.orderList();
  },
};
</script>

<style scoped lang="scss">
@import '../../../../assets/css/table';

.invoice-detail {
  .content-wrapper {
    border: 1px solid #D9D9D9;
    margin-top: 20px;

    .title-box {
      height: 44px;
      line-height: 44px;
      background-color: #F5F5F5;
      color: #333;
      font-size: 16px;
      padding-left: 20px;
      border-bottom: 1px solid #D9D9D9;
    }

    .detail-box {
      padding: 20px;
      font-size: 14px;
      color: #333;

      div {
        margin-bottom: 14px;
      }
    }
  }

  .color-r {
    color: #F0250F;
  }
  .tip {
    height: 16px;
    font-size: 16px;
    font-weight: bold;
    color: #333;
    line-height: 16px;
    margin: 20px 0 10px 0;
  }
  .invoice-info {
    width: 1200px;
    height: 40px;
    line-height: 40px;
    background: rgba(244, 247, 255, 0.4);
    padding-left: 20px;
  }
  .little-tip {
    font-size: 14px;
    font-weight: 400;
    color: #999;
  }
  .margin-left-20 {
    margin-left: 20px;
  }
  .margin-left-32 {
    margin: 20px 0 20px 32px;
  }
  .margin-left-60 {
    margin: 20px 0 20px 60px;
  }
  .margin-left-18 {
    margin: 20px 0 20px 18px;
  }
  .black {
    color: #333;
  }
  .red {
    color: red;
  }
  ::v-deep .el-input {
    width: 300px;
  }
  ::v-deep .el-input__inner {
    height: 30px;
    line-height: 30px;
  }
  ::v-deep .el-select .el-input .el-select__caret {
    margin-top: 4px;
  }
}
</style>
